module.exports = __webpack_public_path__ + "static/img/yaluanwan4.45bd5ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yaluanwan4.png
// module id = jAuv
// module chunks = 52